import endpoints from "./endpoints";
import api from "./api";

export default {
  get(languages) {
    return api.get(endpoints.attributeManager.erpSections.get, { params: { languages } }).then((x) => Promise.resolve(x.data));
  },
  update(model) {
    return api.post(endpoints.attributeManager.erpSections.update, model).then((x) => Promise.resolve(x.data));
  },
  delete(items) {
    return api.post(endpoints.attributeManager.erpSections.delete, items).then((x) => Promise.resolve(x.data));
  }
};
